module.exports = {
  __depends__: [
    require(178),
    require(241),
    require(217),
    require(235),
    require(170),
    require(225)
  ],
  __init__: [ 'move', 'movePreview' ],
  move: [ 'type', require(212) ],
  movePreview: [ 'type', require(213) ]
};
